import optionsApi from "./optionsApi";
import { CustomResponse } from "../types/Grant";
import { DesignatedPersonList } from "../types/designatedPerson";

export async function createDesignatedPerson(
  data: DesignatedPersonList
): Promise<any> {
  return optionsApi
    .post(`v2/designatedPersons/createDesignatedPerson`, data)
    .then((res) => res.data);
}

export async function getAllDesignatedPersons(): Promise<
  DesignatedPersonList[]
> {
  return optionsApi
    .get(`v2/designatedPersons/getAllDesignatedPersons`)
    .then((res) => res.data.data);
}

export async function updateDesignatedPerson(
  data: DesignatedPersonList
): Promise<any> {
  return optionsApi
    .put(`v2/designatedPersons/updateDesignatedPerson`, data)
    .then((res) => res.data);
}

export async function deleteDesignatedPerson(id: string): Promise<void> {
  return optionsApi
    .delete(`v2/designatedPersons/deleteDesignatedPerson`, { params: { id } })
    .then((res) => res.data);
}
